import React from 'react';
import { AnnouncementCategoriesBlock, PageTypeCategoriesBlock } from '../../_blocks/Categories';
import { Icons } from '../../components/atoms/SVG';
import { WidgetType } from '../../types/api/ElementType';
import { ContextWidget } from '../../types/api/Widget';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type PageTypeCategoriesWidget = ContextWidget<PageTypeCategoriesBlock, WidgetType.pagetypecategories>;

export function PageTypeCategoriesWidget(props: PageTypeCategoriesWidget) {
  const { t } = useSonTranslation('Categories');
  return <DefaultContextWidget icon={Icons.CATEGORIES} title={t('widget.headline')} {...props} />;
}

export function AnnouncementCategoriesWidget(props: AnnouncementCategoriesWidget) {
  const { t } = useSonTranslation('Categories');
  return <DefaultContextWidget icon={Icons.CATEGORIES} title={t('widget.headline')} {...props} />;
}

export type AnnouncementCategoriesWidget =
  ContextWidget<AnnouncementCategoriesBlock, WidgetType.announcementcategories>;
